import { TypedDocumentNode, gql } from '@apollo/client';

import { CommonPlayerPreview } from '../CommonPlayerPreview';
import { CommonCardsGrid_composeTeamBenchObjectInterface } from './__generated__/types.graphql';

export const commonCardsGridFragment = gql`
  fragment CommonCardsGrid_composeTeamBenchObjectInterface on ComposeTeamBenchObjectInterface {
    id
    anyPlayer {
      slug
    }
    ...CommonPlayerPreview_composeTeamBenchObjectInterface
  }
  ${CommonPlayerPreview.fragments.composeTeamBenchObjectInterface}
` as TypedDocumentNode<CommonCardsGrid_composeTeamBenchObjectInterface>;
